import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object, string } from "yup";
import PURCHASEIRQWaiveEscrowView from "../views/IrqWaiveEscrowView";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqWaiveEscrowPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            hasWaivedEscrow: string().required(),
          })}
        >
          <PURCHASEIRQWaiveEscrowView
            content={contentMap.RefinanceIrqWaiveEscrowPage}
            navigationsAway={customNavigationMap.RefinanceIrqWaiveEscrowPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqWaiveEscrowPage);
